"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;
var serviceURL = "/reportservice/v1/api/report";
var config = {
  reportBulk: serviceURL + "/bulk",
  report: serviceURL,
  reportEditor: serviceURL + "/editor",
  reportEdit: serviceURL + "/edit",
  reportUpdate: serviceURL + "/update"
};
exports.config = config;